import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { setGlobalFilterOpen } from 'app/employer/redux/filter/actions';

import { FilterIcon } from 'app/employer/vectors/index';

const FilterNoDataAvailable = (props) => {
   const dispatch = useDispatch();

   const handleClick = useCallback((event) => {
      dispatch(setGlobalFilterOpen());
      event.preventDefault();
   });
   return (
      <div className='d-flex align-items-center mt-3 border rounded'>
         <div className='bg-dark-blue rounded-left p-2 mr-3' style={{ marginTop: '-1px', marginLeft: '-1px' }}><FilterIcon width='18' /></div>
         {props.children ? props.children : <div><b>No data available.</b> Please try adjusting your <a href='#' className='text-light-blue' onClick={handleClick}><u>filters</u></a> to see data.</div>}
      </div>
   );
};

export default FilterNoDataAvailable;
